import { facebook, instagram, linkedin, x, contact3, contact4, contact1, contact2 } from "../assets";

export const navLinks = [
  {
    id: "home",
    title: "What We Do",
    href: "/",
  },
  {
    id: "company",
    title: "About Us",
    href: "/company",
  },
  {
    id: "expertise",
    title: "Impact",
    href: "/expertise",
  },
  {
    id: "blog",
    title: "Insights",
    href: "/blog", 
  },
  {
    id: "contact",
    title: "Contact",
    href: "/contact",
  },
];

export const features = [
  {
    id: "feature-1",
    image: contact1,
    title: "Safeguarding & Child Protection",
    content:
      "We support schools to strengthen safeguarding awareness, reporting culture, staff confidence and child protection practice. Our work helps staff understand not only what the policy says but what good safeguarding looks like in everyday school life.",
  },
  {
    id: "feature-2",
    image: contact2,
    title: "School Culture & Staff Practice",
    content:
      "Strong safeguarding depends on strong culture. We help schools build clearer expectations, consistent adult practice and professional routines that support safer, more accountable school communities.",
  },
  {
    id: "feature-3",
    image: contact3,
    title: "Safer Recruitment Advisory",
    content:
      "We support schools to review and strengthen safer recruitment practice, ensuring safeguarding is considered from advertisement to appointment and induction.",
  },
  {
    id: "feature-4",
    image: contact4,
    title: "Ongoing Implementation Support",
    content:
      "Recommendations only matter when they become practice. Aegis offers follow up support to help school leaders review progress, address barriers and embed agreed next steps.",
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Our firm belief in the Promise of Africa drives our mission to resource, cultivate and elevate the next generation of disruptive, tech-driven startups owned and led by visionary African entrepreneurs.", 
  },
];

export const footerLinks = [
  {
    title: "Engage",
    links: [
      { id: "what-we-do", title: "What We Do", href: "/" },
      { id: "about-us", title: "About Us", href: "/company" },
      { id: "impact", title: "Impact", href: "/expertise" },
      { id: "insights", title: "Insights", href: "/blog" },
      { id: "contact", title: "Contact", href: "/contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { id: "safeguarding", title: "Safeguarding", href: "/expertise" },
      { id: "culture", title: "Culture", href: "/expertise" },
      { id: "staff-practice", title: "Staff Practice", href: "/expertise" },
      { id: "safer-recruitment", title: "Safer Recruitment", href: "/expertise" },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    title: "Linkedin",
    icon: linkedin,
    link: "",
  },
  {
    id: "social-media-2",
    title: "X",
    icon: x,
    link: "",
  },
  {
    id: "social-media-3",
    title: "Facebook",
    icon: facebook,
    link: "",
  },
  {
    id: "social-media-4",
    title: "Instagram",
    icon: instagram,
    link: "",
  },  
];

export const creator = [
  {
    id: "github.com/Ndwigar",
    link: "https://github.com/Ndwigar",
    title: "Ndwiga",
  },
];

export const experiences = [
  {
    title: "Sales",
    date: "March 2020 - Present",
    points: [
      "We understand that every project is unique and we take pride in our ability to tailor our solutions to meet specific needs of our clients with integrity and excellence.",
    ],
  },
  {
    title: "Procurement",
    date: "Jan 2021 - Present",
    points: [
      "With deep insights into the unmet clinical needs in Kenya, HSL aims to provide You with comprehensive healthcare solutions and support.",
    ],
  },
  {
    title: "Specialists",
    date: "Jan 2022 - Present",
    points: [
      "We beleive in the power of engineering to transform ideas into tangible realities.",
      "We are driven by a passion for delivering exceptional, structural and mechanical solutions that exceed expectations",
    ]
  },
  {
    title: "Other Services",
    date: "Present",
    points: [
      "HSL has a technical service team that supports its products, from in-service training through to complete operating table rebuilds.",
      "HSL installs equipment, lights, pendants, digital integration, sterilizers Dental, Medical Gases and more.",
      "Also project manages complete medical fit-outs.",
    ],
  },
];







